import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription,  } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import * as NotificationsActions from "../../../../store/notifications/notifications.actions";
import * as PermissionActions from 'src/app/store/permissions/permissions.actions';
import { ActivatedRoute } from '@angular/router';
import { selectPinSetting, selectValidToken } from 'src/app/store/permissions/permissions.selector';

@Component({
  selector: 'app-pin',
  templateUrl: './pin.component.html',
})

export class PinComponent implements OnInit, OnDestroy {
   // Store selectors
   validToken$: Observable<boolean | undefined>;
   validTokenSub: Subscription | undefined;
   pinSetting$: Observable<boolean | undefined>;
   pinSettingSub: Subscription | undefined;


   token = '';

   pin = '';
   pinRepeat = '';

   repeatError = false;

   stepNo = 1;
   pinSetting: boolean;

   // Design
   screenWidth: number;
   MIN_MD_WIDTH = 500;
   COLUMN_TITLE_MIN_WD = 647;
   MAX_MD_WIDTH = 1120;
   MIN_WIDTH_MX7 = 1700;
   LG_WIDTH = 1500;

   MAX_MD_WIDTH_SHORT = 858;

   constructor(
      private store: Store<AppState>,
		private route: ActivatedRoute,
   ) {
      this.initSelectors();
   }

   initSelectors(): void {
      // Store selectors
      this.validToken$ = this.store.select(selectValidToken);
      this.pinSetting$ = this.store.select(selectPinSetting);
   }

   ngOnInit() {
      this.store.dispatch(NotificationsActions.setTopbarTitleId({
         stringId: 'SELECT_PINPAD'
      }));
      this.token = this.route.snapshot.params['token'];
      this.validTokenSub = this.validToken$.subscribe(valid => {
          if (!valid) {
              this.stepNo = 100;
          }
      });
      this.pinSettingSub = this.pinSetting$.subscribe(pinSetting => {
         this.pinSetting = pinSetting;
     });
   }

   ngOnDestroy() {
      this.validTokenSub?.unsubscribe();
      this.pinSettingSub?.unsubscribe();
   }

   
   onPinInserted(event: number[]) {
      if (this.stepNo === 1) {
          this.pin = event.join('');
          this.stepNo = 2;
      } else if (this.stepNo === 2) {
          this.pinRepeat = event.join('');
          this.checkComplete();
      }
  }

  checkComplete(): void {
      if (this.pinRepeat !== this.pin) {
          this.repeatError = true;
          return;
      }
      this.repeatError = false;
      this.stepNo = 3;
      this.store.dispatch(PermissionActions.setPin({ token: this.token, pin: this.pin }));
  }

  reset(): void {
      this.pin = '';
      this.pinRepeat = '';
      this.stepNo = 1;
      this.repeatError = false;
  }

   // Design
   @HostListener('window:resize')
   onResize() {
      this.screenWidth = window.innerWidth;
   }

   onMobile(): boolean {
      return (this.screenWidth <= this.MIN_MD_WIDTH);
   }

   onTablet(): boolean {
      return (this.screenWidth >= this.MIN_MD_WIDTH) && (this.screenWidth <= this.MAX_MD_WIDTH_SHORT);
   }

   layoutMarginResponsive(): string {
      return (this.screenWidth >= this.MIN_WIDTH_MX7) ? "mx-7" : "mx-2";
   }

   dynamicInputTextWidth(): string {
      return (this.screenWidth <= this.COLUMN_TITLE_MIN_WD) ? "w-full h-2_5rem" : "w-25rem h-2rem";
   }

   col12Responsive(): string {
      return (this.screenWidth <= this.MAX_MD_WIDTH) ? "col-12 p-2" : "col-6 p-2";
   }

}
